export default __webpack_public_path__ + "static/media/list-color-correct.274e42ae.png";